import React, { useState, useEffect } from "react";
import "./style.scss";
import { Paper } from "@material-ui/core";
import {
  MasterButton,
  ModalDefaultError,
  ModalDeleteConfirm,
  TableToolbar,
} from "App/Component/ui";

import { STYLE_DEFAULT_MASTER } from "App/constants/theme";
import { getAllListMenu, deleteMenuById, RESET_STATE_MENU } from "./helpers";
import ModalForm from "./ModalForm";
import RenderContent from "./RenderContent";

export default function Menu() {
  const classes = STYLE_DEFAULT_MASTER();

  const [showModal, setShowModal] = useState(false);
  const [showModalDefaultError, setShowModalDefaultError] = useState(false);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  const [rows, setRows] = useState([]);
  const [formData, setFormData] = useState(RESET_STATE_MENU);
  const [run, setRun] = useState(false);

  useEffect(() => {
    (async () => {
      const res = await getAllListMenu();
      if (res) {
        setRows(res);
      } else {
        setShowModalDefaultError(true);
      }
    })();
  }, [run]);

  return (
    <div className={classes.root}>
      {showModal && (
        <ModalForm
          run={() => setRun(!run)}
          setShowModal={() => setShowModal(false)}
          formData={formData}
          setFormData={setFormData}
        />
      )}

      {showModalDefaultError && (
        <ModalDefaultError
          setShowModalDefaultError={() => setShowModalDefaultError(true)}
        />
      )}

      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() =>
            deleteMenuById(
              formData.id,
              () => setRun(!run),
              setShowModalDeleteConfirm,
              setFormData
            )
          }
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      <Paper className={classes.paper}>
        <TableToolbar title={"Daftar Menu"}>
          {/* <SearchInput withIcon={true} onchange={(e) => setQ(e.target.value)} /> */}
          <MasterButton
            type={"submit"}
            color='green'
            name='Tambah'
            size='md'
            onClick={() => {
              setFormData(RESET_STATE_MENU);
              setShowModal(!showModal);
            }}
          />
        </TableToolbar>
        <RenderContent
          rows={rows}
          formData={formData}
          setFormData={setFormData}
          setShowModalDeleteConfirm={setShowModalDeleteConfirm}
          setShowModal={setShowModal}
        />
      </Paper>
    </div>
  );
}
